import { useQuery } from "@apollo/client";
import { Box, Flex, Heading, Text } from "rebass/styled-components";
import styled from "styled-components";
import { Skeleton } from "../../../../components/loadingSkeleton/Skeleton";
import PleaseWait from "../../../../components/PleaseWait";
import { GET_SPEAKER_SERIES } from "../../../../graphql/queries";
import { IGetSpeakerSeriesInput, IgetSpeakerSeriesOutput, ISpeakerSerie } from "../../../../graphql/types/queries/speakerSeries";

const SpeakerCardWrapper = styled(Flex)`
  width: 100%;
  background: #dae5fb;
  height: 253px;
  min-height: 253px;
  overflow: hidden;
  box-shadow: 0px 4px 20px rgb(0 0 0 / 15%);
  transition: all 300ms ease;
  position: relative;
  cursor: pointer;
  &:hover {
    box-shadow: 0px 4px 20px rgb(0 0 0 / 33%);
  }
  @media screen and (max-width: 68.8125em) {
    width: calc(100vw - 24px);
    max-width: 100vw;
    flex-direction: column;
    height: auto;
    border-radius: 10px;
  }
`;

const TextWrapper = styled(Flex)`
  width: 236px;
  height: 100%;
  @media screen and (max-width: 68.8125em) {
    width: 100%;
    max-width: 100%;
    flex-direction: column;
    height: initial;
  }
`;

const Description = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  flex: 1;
  font-size: 14px;
  @media screen and (max-width: 68.8125em) {
    margin-bottom: 12px;
  }
`;

const SpeakerCard = ({ serie, isSelected, onSelect, canSelect = true }: { canSelect?: boolean, serie: ISpeakerSerie, isSelected: boolean, onSelect: () => void }) => {
  return (
    <SpeakerCardWrapper mb={4} onClick={() => window.open(serie.videoLink, '_blank')}>
      <Flex flexDirection={'column'} style={{ overflow: 'hidden' }} flex={['initial', 1,1]}>
        <img src={((serie || {}).image || '').replace('.png', '') + '-p-800.png'} height="100%" width="100%" style={{ objectFit: 'cover' }} />
      </Flex>
      <TextWrapper flexDirection={'column'} style={{ background: 'white', padding: '22px', overflow: 'hidden' }}>
        <Heading fontSize={'18px'}>{serie.name}</Heading>
        <Description>{serie.smallDescription}</Description>
      </TextWrapper>
      {!!canSelect && (
        <Flex onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
          onSelect()
        }} style={{ paddingBottom: '8px', position: 'absolute', right: 0, top: 0, width: '80px', height: '55px', justifyContent: 'center', alignItems: 'flex-end', transformOrigin: 'bottom right', transform: 'rotate(45deg)', background: !isSelected ? 'white' : '#344F7A', boxShadow: '0px 4px 20px rgb(0 0 0 / 33%)' }}>
          {isSelected ? (<svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5V15C0 16.3261 0.526784 17.5979 1.46447 18.5355C2.40215 19.4732 3.67392 20 5 20H15C16.3261 20 17.5979 19.4732 18.5355 18.5355C19.4732 17.5979 20 16.3261 20 15V5C20 3.67392 19.4732 2.40215 18.5355 1.46447C17.5979 0.526784 16.3261 0 15 0H5ZM13.73 8.684C13.8198 8.58814 13.8899 8.47552 13.9362 8.35257C13.9825 8.22963 14.0041 8.09878 13.9998 7.96747C13.9956 7.83617 13.9655 7.707 13.9113 7.58732C13.8571 7.46765 13.7799 7.35982 13.684 7.27C13.5881 7.18018 13.4755 7.11011 13.3526 7.06381C13.2296 7.01751 13.0988 6.99588 12.9675 7.00015C12.8362 7.00442 12.707 7.03451 12.5873 7.08871C12.4677 7.1429 12.3598 7.22014 12.27 7.316L9.187 10.606L7.664 9.253C7.46446 9.08712 7.20825 9.0053 6.9495 9.02482C6.69075 9.04434 6.44972 9.16368 6.27732 9.35762C6.10493 9.55156 6.01467 9.80492 6.02562 10.0642C6.03657 10.3234 6.14787 10.5683 6.336 10.747L8.586 12.747C8.78069 12.9199 9.03515 13.0101 9.29529 12.9983C9.55543 12.9866 9.80072 12.8738 9.979 12.684L13.729 8.684H13.73Z" fill="white" />
          </svg>
          ) : (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17 3H7C4.79086 3 3 4.79086 3 7V17C3 19.2091 4.79086 21 7 21H17C19.2091 21 21 19.2091 21 17V7C21 4.79086 19.2091 3 17 3Z" stroke="#344F7A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          )}
        </Flex>
      )}
    </SpeakerCardWrapper>
  );
};

const SpeakerCardLoading = () => {
  return (
    <SpeakerCardWrapper mb={4}>
      <Flex flexDirection={'column'} style={{ overflow: 'hidden', justifyContent: 'center', alignItems: 'center' }} flex={1}>
        <PleaseWait
          text={' '}
        />
      </Flex>
      <Flex flexDirection={'column'} style={{ background: 'white', width: '236px', height: '100%', padding: '22px', overflow: 'hidden' }}>
        <Heading fontSize={'18px'} mb={3}>
          <Skeleton height="20px" width="180px" />
        </Heading>
        <Skeleton height="14px" width="200px" />
        <Skeleton height="14px" width="180px" />
        <Skeleton height="14px" width="100px" />
      </Flex>
    </SpeakerCardWrapper>
  );
};

const SpeakerSeries = ({ selectedSpeakerSeries, setSelectedSpeakerSeries, canSelect = true }: { canSelect?: boolean, selectedSpeakerSeries: Array<ISpeakerSerie | null>, setSelectedSpeakerSeries: (speakerSerie: ISpeakerSerie) => void }) => {
  const { loading, data } = useQuery<IgetSpeakerSeriesOutput, IGetSpeakerSeriesInput>(GET_SPEAKER_SERIES)

  return (
    <Flex flex={1} maxHeight={['100%', 'initial', 'initial']}>
      <Flex flexDirection={'column'} 
      alignItems={['center', '','']} 
      paddingLeft={['', '22px', '22px']} 
       style={{ overflowY: "auto",maxWidth: '700px', width: '100%', paddingTop: '12px' }}>
        {!!loading
          ? [...Array(12)].map((x, i) => {
            return <SpeakerCardLoading key={`loadingSpeakerSerie${i}`} />;
          })
          : ((data || {}).getSpeakerSeries || [] as Array<ISpeakerSerie>).map((x) => {
            return <SpeakerCard
              serie={x}
              canSelect={canSelect}
              key={`SpeakerSerie${x.id}`}
              onSelect={() => setSelectedSpeakerSeries(x)}
              isSelected={selectedSpeakerSeries.findIndex(z => z?.id === x.id) > -1} />;
          })}
          <Box display={['initial', 'none', 'none']} width={'100%'} minHeight='150px' />
      </Flex>
    </Flex>
  );
}

export default SpeakerSeries